import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

export const showAnimateTop = (ref, triggerElem, arrayCountEls) => {
  if (!ref.current || !ref.current.children?.[0]) return null;
  const t14 = gsap.timeline();

  if (ref.current?.children?.[0]) {
    [...ref.current.children].forEach((_, index) => {
      t14.to(ref.current.children[index], {
        scrollTrigger: {
          id: 'trigger14',
          trigger: triggerElem,
          scroller: window.innerWidth >= 741 ? '#smooth-wrapper' : 'body',
          start: 'top top-=50px',
          pin: false,
          onToggle: () => {
            setTimeout(() => {
              ref.current.children[index].classList.add('will-show-animate');
              if (arrayCountEls) {
                arrayCountEls.forEach(item => {
                  animateValue(item, 500);
                });
              }
            }, 150);
          },
        },
      });
      return null;
    });
  }

  ScrollTrigger.refresh();

  return () => {
    if (ScrollTrigger.getById('trigger14')) {
      t14.kill();
      ScrollTrigger.getById('trigger14').kill();
    }
  };
};

export const showAnimate = (ref, triggerElem, arrayCountEls) => {
  if (!ref.current) return null;

  const animateElement = (element, index, start) => {
    const scroller =
      window.innerWidth >= 741 ? document.querySelector('#smooth-wrapper') || document.body : document.body;

    const tl = gsap.timeline();
    tl.to(element, {
      scrollTrigger: {
        id: `trigger${index}`,
        trigger: triggerElem,
        scroller,
        start: `bottom bottom-=${start}px`,
        pin: false,
        onToggle: () => {
          setTimeout(() => {
            element.classList.add('will-show-animate');
            if (arrayCountEls) {
              arrayCountEls.forEach(item => {
                animateValue(item, 500);
              });
            }
          }, 150);
        },
      },
    });
    return tl;
  };

  let tl;
  if (ref.current?.children?.[0]) {
    [...ref.current.children].forEach((_, index) => {
      tl = animateElement(ref.current.children[index], index + 16, 50);
    });
  } else {
    tl = animateElement(ref.current, 17, 30);
  }

  ScrollTrigger.refresh();

  return () => {
    if (tl) {
      tl.kill();
      ScrollTrigger.getById(`trigger${tl.vars.id.slice(-2)}`).kill();
    }
  };
};

export const animateValue = (el, duration) => {
  if (el.dataset.animated) return;

  el.dataset.animated = true;
  const startNumber = Number.parseFloat(el.dataset.startNumber);
  const end = Number.parseFloat(el.textContent);

  if (startNumber === end) return;

  const range = end - startNumber;
  let current = startNumber;
  const increment = end > startNumber ? 1 : -1;
  const stepTime = Math.abs(Math.round((duration / range) * 100) / 100);

  const updateValue = () => {
    current += increment;
    el.textContent = current;
    if ((increment === -1 && current < end) || (increment === 1 && current > end)) {
      clearInterval(timer);
      el.textContent = end;
    }
  };

  const timer = setInterval(updateValue, stepTime);
};

export const getCookie = cname => {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];

    while (c.charAt(0) === ' ') {
      c = c.slice(1);
    }
    if (c.indexOf(name) === 0) {
      return c.slice(name.length, c.length);
    }
  }

  return '';
};

export const setCookie = (cname, cvalue, exdays) => {
  const d = new Date();

  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);

  const expires = 'expires=' + d.toUTCString();

  document.cookie = `${cname}=${cvalue}; ${expires};path=/`;
};

export const generateNewUserDate = () => {
  const getLocaleDate = new Date().toLocaleDateString();
  const getHours = new Date().getHours();
  const getMinutes = new Date().getMinutes();
  const getSeconds = new Date().getSeconds();

  return `${getLocaleDate}/${getHours}/${getMinutes}/${getSeconds}`;
};

export const deleteCookie = name => {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};
